
import TableList from "@components/templates/tablelist";
import { HttpGetBrushReviewList, HttpGetBrushReviewActive, HttpGetBrushReviewDelete} from "@/service/products/brushreview";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
import {Button, Dropdown, DropdownItem, DropdownMenu, Icon} from "view-design";
import compBatchUpload from "./upload";
export default {
    mixins: [TableList],
    components: {
        comIndex,
        compBatchUpload
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },

    methods: {
        ajaxRequest: HttpGetBrushReviewList,
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'brushReviewUpdate',
                        params: { type: "add"},
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'brushReviewUpdate',
                        params: { type: "edit"},
                        query: { id: params},
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case 'export':
                    if(this.total>2000){
                        this.$VMessage.error('导出数据不能大于2000');
                    }else{
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/brushReview/resource/exportByFilter',this.formData,{
                            executor:'request',
                            download:true,
                        }).catch(err=>{
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    }
                    break;
                case "active":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params},
                        title: "启用操作",
                        ajaxRequest:HttpGetBrushReviewActive
                    }
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params},
                        title: "停用操作",
                        ajaxRequest:HttpGetBrushReviewDelete
                    }
                    break;
                case "multipleUpload":
                    this.operate = {
                        show: true,
                        title: "批量上传附件",
                        width: 450,
                        // ids: params,
                        showFooter: false,
                        component: compBatchUpload,
                        on: {
                            "on-cancel": () => {
                                this.operate.show = false;
                            }
                        }
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('diction',['getAllProductPerson']),
        ...mapGetters('dictionary',['getCountryList']),

        TabsData(){
            return [
                {
                    label: `所有资源`,
                    key:'EQ_status',
                    val: null
                },
                {
                    label: `可用资源`,
                    key:'EQ_status',
                    val: 1
                },{
                    label: `停用资源`,
                    key:'EQ_status',
                    val: 0
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "info",
                },
                {
                    name: "查询条件导出",
                    operate: "export",
                    theme: "primary",
                    // batch:true,
                },
                {
                    name: "批量激活",
                    operate: "active",
                    theme: "success",
                    batch:true,
                },
                {
                    name: "批量停用",
                    operate: "delete",
                    theme: "warning",
                    batch:true,
                },
                {
                    name: "批量上传附件",
                    operate: "multipleUpload",
                    theme: "success",
                    // batch: true,
                }
            ]
        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: "Email",
                    tag: 'vInput',
                    key: 'CN_email',
                    show:true,
                },
                {
                    label: "姓名",
                    tag: 'vInput',
                    key: 'CN_name',
                    show:true,
                },
                {
                    label: '开始合作时间',
                    tag: 'vDatepicker',
                    key: 'BT_beginTime',
                    style: "width:180px",
                    hidden: !(this.formData.search['all'] == null),
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },

                // 隐藏起来的搜索
                {
                    label: "负责人",
                    tag: 'vSelect',
                    key: 'EQ_manageId',
                    hidden:!(this.formData.search['all']==null),
                    options: this.getAllProductPerson.map((item) => {
                        return {
                            value: item.attach.id,
                            label: item.label
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "个人link",
                    tag: 'vInput',
                    key: 'CN_link',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "AmazonProfile",
                    tag: 'vInput',
                    style: "width:180px",
                    key: 'CN_amazonProfile',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: '来源渠道',
                    style: "width:250px",
                    key: "IN_sourceAccount",
                    hidden:!(this.formData.search['all']==null),
                    props: {
                        readonly: false,
                        multiple: true,
                    },
                    tag: "vSelect",
                    options: [
                        {
                            value: '微信',
                            label: '微信'
                        },
                        {
                            value: 'facebook',
                            label: 'facebook'
                        },
                        {
                            value: 'email',
                            label: 'email'
                        },
                        {
                            value: 'testzon',
                            label: 'testzon'
                        },
                        {
                            value: '朋友介绍',
                            label: '朋友介绍'
                        },
                        {
                            value: '其他',
                            label: '其他'
                        },
                    ],
                },
                {
                    label: "国别",
                    key: 'EQ_country',
                    tag: 'vSelect',
                    options:this.getCountryList,
                    props:{
                        dropStyle,
                        filterable:true,
                    },
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "备注",
                    tag: 'vInput',
                    key: 'CN_remark',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 70,
                    render: (h, { row }) => {
                        const id = row.id;
                        if(row.status == 1){
                            return <Dropdown placement="bottom-start" trigger="click">
                                <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                    <DropdownMenu slot="list" class="text-left">
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</DropdownItem>
                                        <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'edit')}>编辑</DropdownItem>
                                        <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'delete')}>停用</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown >
                        }else {
                            return <Dropdown placement="bottom-start" trigger="click">
                                <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                    <DropdownMenu slot="list" class="text-left">
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</DropdownItem>
                                        <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'active')}>启用</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown >
                        }
                    }
                },
                {
                    title: '姓名',
                    render: (h, { row }) => {
                        return <div><a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.name}</a></div>
                    }
                },
                {
                    title: '负责人',
                    render: (h, { row }) => {
                        const manageId = row.manageId;
                        const manage = this.getAllProductPerson.filter((item) => {
                            return manageId == item.attach.id
                        })[0] || {};
                        return <div>{manage.label}</div>
                    }
                },
                {
                    title: '资源信息',
                    width: 350,
                    render: (h, { row }) => {
                        return <div>
                                    <div><span class="font-bold">Email: </span>{row.email || '--'}</div>
                                    <div><span class="font-bold">个人link: </span>{row.link}</div>
                                    <div><span class="font-bold">Profile: </span>{row.amazonProfile}</div>
                              </div>
                    },
                },
                {
                    title: '来源渠道/国别',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.sourceAccount}</div>
                        <div>{row.country}</div>
                        </div>
                    }
                },
                {
                    title: '开始合作时间',
                    render: (h, { row }) => {
                        return <div>{row.beginTime || '--'}</div>
                    }
                },
                {
                    title: '状态',
                    render: (h, { row }) => {
                        return <div>{row.status == 1 ? '可用' : '停用'}</div>
                    }
                },
                {
                    title: '创建时间',
                    render: (h, { row }) => {
                        return <div>{row.createdAt}</div>
                    }
                },
            ];
        },

    },

};
